import React from "react";
import Container from "components/Docs/Container";
import { usePageProps } from "utils/hooks/docs";
import Padder from "components/Padder";
import NextPrevNav from "components/NextPrevNav";
import { DESKTOP } from "utils/constants/ui";
import { useRouter } from "next/router";
import { getStaticContainerMeta } from "utils/metadata";

const DocsLayout = ({ children, frontMatter, navConfig }) => {
  const props = usePageProps({ frontMatter, navConfig });
  return <Container {...props}>{children}</Container>;
};

export default DocsLayout;
